import AppDispatcher from '../../core/AppDispatcher'
import CheckInEvent from '../../event/CheckInEvent'

const disposePassport = (reservationId, passportUrl, index) => {
  AppDispatcher.dispatchWithType(CheckInEvent.disposePassport, { index: index })
  return true
}

export default disposePassport
